module.exports = __webpack_public_path__ + "static/media/spilled_wine.ec65b2d3.svg";